import React from 'react';

const ParkingResults = () => {
  return (
    <div id="App"></div>
  );
};

export default ParkingResults; 